import QRCode from 'qrcode';

export const getInvoiceQrCode = async (token) => {
  const qrCode = await QRCode.toDataURL(`${process.env.REACT_APP_BASE_URL}/invoice/${token}`);
  return qrCode;
};
